import type {ReactElement} from 'react';
import {SkeletonBrick} from '@Components/skeleton-brick/skeleton-brick';
import {resolveSkeletonBrickTheme} from '@Components/ai-chat-window/lib/skeleton.library';
import type {EntityDraftSkeletonProps} from './entity-draft-skeleton.types';
import {SKELETON_DRAFT_MEDIA_HEIGHT, SKELETON_DRAFT_META_WIDTH, SKELETON_DRAFT_STATUS_WIDTH, SKELETON_DRAFT_TEXT_LINE_HEIGHT} from './entity-draft-skeleton.types';
import styles from './entity-draft-skeleton.module.scss';

/**
 * Transient placeholder mirroring the entity-draft-card layout, shown while the agent is still
 * composing the draft. Replaced by the streamed intro text / real draft card.
 */
export function EntityDraftSkeleton({mode}: EntityDraftSkeletonProps): ReactElement {
  const theme = resolveSkeletonBrickTheme(mode);

  return (
    <div className={styles.entityDraftSkeleton}>
      <div className={styles.skeletonTextLines}>
        <SkeletonBrick width={SKELETON_DRAFT_META_WIDTH} height={SKELETON_DRAFT_TEXT_LINE_HEIGHT} radius="4px" theme={theme} />
        <SkeletonBrick width={SKELETON_DRAFT_STATUS_WIDTH} height={SKELETON_DRAFT_TEXT_LINE_HEIGHT} radius="4px" theme={theme} />
      </div>
      <SkeletonBrick width="100%" height={SKELETON_DRAFT_MEDIA_HEIGHT} radius="12px" theme={theme} />
    </div>
  );
}
